export class SaveCostApproval {
    RequestId :number;
	RequirementType:any;
	RMHCode:any;
	RMHName:any;
	Product:any;
	WHLocation:any;
	SD:any;
	RequestedQTY:any;
	StockAvailable:any;
	FinalQTY:any;
	ApprovedQTY:any;
	TotalCost:any;
	IsSelected:boolean;
	Remark:any;
	CostApprovalId :any;
	RequestDetailId:any;;
	cropId:number;
	productId:any;
	packSize:any;
	status:any;
	fmcstRemark:any;
	fmcstStatus:any;
    
}